@if (size() === 'compact') {
  <svg class="error-state-icon" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"/>
  </svg>
  <span>{{ key() + '.short' | translate }}</span>
  @if (canRetry()) {
    <app-icon-text-button size="compact" icon="assets/icons/refresh-cw-01.svg" (click)="onRetry($event)">{{ 'global.loadError.retry' | translate }}</app-icon-text-button>
  }
} @else {
  <!-- The empty state's chip (KAB-2132), on its illustration for a page: an outage in pink, a refusal or a deleted item in grey -->
  <div class="error-state-visual">
    @if (size() === 'page') {
      <img class="error-state-illustration" src="assets/illustrations/inventory-placeholder.svg" width="318" height="184" alt="">
    }
    <span class="error-state-chip" [class]="error()">
      @switch (error()) {
        @case ('forbidden') {
          <svg viewBox="0 0 13 13" aria-hidden="true" class="thin">
            <path d="M9.20963 5.41667V4.33333C9.20963 2.83756 7.99707 1.625 6.5013 1.625C5.00553 1.625 3.79297 2.83756 3.79297 4.33333V5.41667M6.5013 7.85417V8.9375M4.76797 11.375H8.23463C9.14472 11.375 9.59976 11.375 9.94737 11.1979C10.2531 11.0421 10.5017 10.7935 10.6575 10.4877C10.8346 10.1401 10.8346 9.68508 10.8346 8.775V8.01667C10.8346 7.10658 10.8346 6.65154 10.6575 6.30393C10.5017 5.99817 10.2531 5.74958 9.94737 5.59378C9.59976 5.41667 9.14472 5.41667 8.23463 5.41667H4.76797C3.85788 5.41667 3.40284 5.41667 3.05523 5.59378C2.74947 5.74958 2.50088 5.99817 2.34508 6.30393C2.16797 6.65154 2.16797 7.10658 2.16797 8.01667V8.775C2.16797 9.68508 2.16797 10.1401 2.34508 10.4877C2.50088 10.7935 2.74947 11.0421 3.05523 11.1979C3.40284 11.375 3.85788 11.375 4.76797 11.375Z"/>
          </svg>
        }
        @case ('notFound') {
          <svg viewBox="0 0 14 14" aria-hidden="true" class="thin">
            <path d="M5.25 1.75H8.75M1.75 3.5H12.25M11.0833 3.5L10.6743 9.63625C10.6129 10.5569 10.5822 11.0172 10.3833 11.3663C10.2083 11.6735 9.94423 11.9206 9.62597 12.0748C9.26448 12.25 8.80314 12.25 7.88045 12.25H6.11955C5.19686 12.25 4.73552 12.25 4.37403 12.0748C4.05578 11.9206 3.79172 11.6735 3.61666 11.3663C3.41781 11.0172 3.38713 10.5569 3.32575 9.63625L2.91667 3.5M5.83333 6.125V9.04167M8.16667 6.125V9.04167"/>
          </svg>
        }
        @default {
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"/>
          </svg>
        }
      }
    </span>
  </div>
  <p class="error-state-message">
    <span class="error-state-title">{{ key() + '.title' | translate }}</span>
    <span class="error-state-text">{{ key() + '.text' | translate }}</span>
  </p>
  @if (canRetry()) {
    <app-icon-text-button size="default" icon="assets/icons/refresh-cw-01.svg" (click)="onRetry($event)">{{ 'global.loadError.retry' | translate }}</app-icon-text-button>
    @if (size() === 'page') {
      <span class="error-state-help">
        {{ 'global.loadError.persist' | translate }}
        <button type="button" class="error-state-link" (click)="openChat()">{{ 'global.loadError.chat' | translate }}</button>
      </span>
    }
  }
}
